import { render, staticRenderFns } from "./LibTourPageHeader.vue?vue&type=template&id=539ff4b8&scoped=true&"
import script from "./LibTourPageHeader.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LibTourPageHeader.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ff4b8",
  null
  
)

export default component.exports